import Vue from "vue";
import { MLInstaller, MLCreate, MLanguage } from "vue-multilanguage";

Vue.use(MLInstaller);

const texteDeu = {
  Nav: {
    title: "Rutschenkonfigurator",
    highscore: "Highscore",
    strecken: "Strecken",
  },
  Home: {
    title: "Rutschenkonfigurator",
    subTitle:
      "Du willst, dass dein Besuch im AquariUM etwas ganz besonderes wird?",
    text:
      "Kein Problem - mit dem Rutschenkonfigurator kannst du dein individuelles Rutschenprofil schon direkt von Zuhause oder unterwegs aus erstellen. Bestimme die Musik, das Licht und viele weitere Spektakuläre Effekte für bis zu sechs individuelle Rutschenprofile. Wenn du dann vor Ort oben auf der Rutsche stehst, kannst du aus deinen eignenen und drei voreingstellten Rutschenprofilen wählen.",
    textNewAccount: "Neu hier?",
    btnAnmelden: "Anmelden",
    btnRegistrieren: "Registrieren",
    btnNewAccount: "Account erstellen",
    btnBack: "Zurück",
    placeholderCode: "4-stelliger Zahlencode",
    labelPassword: "Passwort",
    confirm: "Passwort bestätigen",
    forgotPassword: "Passwort vergessen?",
    anmelden: "Anmeldung",
    registrieren: "Registrieren",
    Impressum: "Impressum",
    Datenschutz: "Datenschutz",
    Kontakt: "Kontakt",
  },
  Footer: {
    Impressum: "Impressum",
    Datenschutz: "Datenschutz",
    Kontakt: "Kontakt",
    linkImpressum: "https://aquarium-schwedt.de/impressum",
    linkDatenschutz: "https://aquarium-schwedt.de/datenschutz",
    linkKontakt: "https://aquarium-schwedt.de/service#kontakt",
  },
  Login: {
    title: "HALLO, LIEBE SLIDER!",
    text:
      "Meldet euch mit eurem Nickname und eurem Passwort an. Sobald ihr eingeloggt seid, könnt ihr eure persönlichen Strecken konfigurieren oder euch die Slider-Statistiken ansehen.",
    name: "Nickname",
    loggedIn:
      "Hi {name}, du bist bereits eingeloggt. Hier kannst du dich ausloggen:",
    loggedInAlternative:
      "Hi <b>{newUser}</b>, du bist derzeit noch als <b>{name}</b> eingeloggt. Hier kannst du dich ausloggen:",
    validation: "Dein Nickname muss mind. 3 Buchstaben oder Zahlen haben.",
    validationPassword: "Passwort muss aus 4 Zahlen bestehen.",
    labelPassword: "Passwort",
    placeholderCode: "4-stelliger Zahlencode",
    connectProfile: "Anmelden und verknüpfen",
    anmelden: "Anmelden",
    wait: "Bitte warten...",
  },
  Register: {
    title: "HALLO, LIEBE SLIDER!",
    text:
      "Ihr müsst euch zuerst registrieren, damit ihr eure persönlichen Strecken konfigurieren oder euch die Slider-Statistiken ansehen könnt. Meldet euch mit eurem Nickname und eurem Passwort an. Sobald ihr eingeloggt seid, könnt ihr eure persönlichen Strecken konfigurieren oder euch die Slider-Statistiken ansehen.",
    name: "Nickname *",
    loggedIn:
      "Hi {name}, du bist bereits eingeloggt. Hier kannst du dich ausloggen:",
    noToken:
      "Hi, bitte geh zurück auf login.aquarium-schwedt.de/rutschenkonfigurator und klicke auf 'Neuen Rutscher anlegen'",
    validation: "Dein Nickname muss mind. 3 Buchstaben oder Zahlen haben.",
    validationHint: "3-12 Buchstaben oder Zahlen",
    validationPassword: "Passwort muss aus 4 Zahlen bestehen.",
    validationPassword2: "Passwort muss übereinstimmen.",
    labelPassword: "Passwort *",
    labelPassword2: "Passwort wiederholen *",
    placeholderCode: "4-stelliger Zahlencode",
    connectProfile: "Anmelden und verknüpfen",
    register: "Jetzt Registrieren",
    wait: "Bitte warten...",
    birthday: "Geburtsdatum",
    gender: "Geschlecht",
    options: "Bitte triff deine Auswahl",
    info: "Mit * gekennzeichnete Felder sind Pflichtfelder.",
  },
  ConfigTile: {
    platzhalter: "Hier ist noch Platz für eine Strecke",
  },
  ConfiguratorStart: {
    title: "Konfigurator",
    nameIt: "Gib deiner Strecke einen Namen",
    instruction:
      "Lass deiner Phantasie freien Lauf und suche dir einen tollen Namen für deine individuelle Strecke aus!",
    btnCancel: "Abbrechen",
    btnGo: "Los geht's",
  },
  Configurator: {
    title: "Neue Strecke",
    btnNewSlide: "Strecke erstellen",
    btnSaveSlide: "Speichern",
    btnBack: "Zurück",
    btnProceed: "Weiter",
    langsam: "sehr langsam",
    normal: "normal",
    schnell: "schnell",
    streckeVerwerfen: "Strecke verwerfen",
    streckeErstellen: "Strecke erstellen",
    aenderungenVerwerfen: "Änderungen verwerfen",
    aenderungenSpeichern: "Änderungen speichern",
    frageZufrieden: "Nicht zufrieden?",
    color: "Farbe",
    speed: "Speed",
    effekt: "Effekt",
    abschnitt: " Abschnitt",
    musik: "Musik",

    instruction1:
      "Wähle zuerst einen Lichteffekt für den {step}. Rutschenabschnitt und stelle dann eine Geschwindigkeit ein. Danach wählst du den Farbeffekt. In der Vorschau kannst du deinen Abschnitt kontrollieren. Wenn du fertig bist, klicke auf „Weiter“. So gelangst du zum {nextstep}. Abschnitt.",
    instruction2:
      "Stelle die Geschwindigkeit für den {step}. Rutschenabschnitt ein. Danach wählst du den Farbeffekt. In der Vorschau kannst du deinen Abschnitt kontrollieren. Wenn du fertig bist, klicke auf „Weiter“. So gelangst du zum {nextstep}. Abschnitt.",
    instruction3:
      "Stelle die Geschwindigkeit für den {step}. Rutschenabschnitt ein. Danach wählst du den Farbeffekt. In der Vorschau kannst du deinen Abschnitt kontrollieren. Wenn du fertig bist, klicke auf „Weiter“. So gelangst du zur Übersicht in der du deine Musik wählen kannst.",
    title4: "Sieht gut aus!",

    instruction4:
      "Super! Du hast nun alle Abschnitte gestaltet! Jetzt fehlt deiner Strecke nur noch der Sound. Wähle aus der Liste deinen persönlichen Lieblingshit, den du dir zur Probe anhören kannst. Wenn auch die Musik passt, klicke auf {label}. Fertig!",
    musicDescription: "Wie klingt deine Strecke?",
    music: "Musik",
    musicChoice: "Bitte triff deine Auswahl",
  },
  LogoutDialog: {
    option1: "Abmelden und<br /> zurück zum Slider-Profil",
    option2: "<b>Ohne</b> Abmelden<br /> zurück zum Slider-profil",
    btnCancel: "Abbrechen",
    link: "https://login.aquarium-schwedt.de/rutschenkonfigurator",
  },
  MusicPlayer: {
    listen: "<b>Probehören</b>",
  },
  Notification: {
    title404: "Server nicht erreichbar",
    text404:
      "Der Server ist aktuell nicht erreichbar. Bitte probiere es zu einem späteren Zeitpunkt erneut.",
    title401: "Bitte überprüfe deine Eingaben",
    text401:
      "Der Server ist aktuell nicht erreichbar. Bitte probiere es zu einem späteren Zeitpunkt erneut.",
    titleGeneral: "Ups!",
    textGeneral:
      "Da ist etwas schief gelaufen oder der Server ist nicht zu erreichen. Bitte probiere es erneut!",
    2000: "Der Benutzername wird bereits verwendet. Bitte wähle einen anderen Namen.",
    2010: "Der Benutzername ist zu lang oder zu kurz",
    2015: "Bitte gib deinen Benutzernamen und Passwort an.",
    2020: "Der Benutzername enthält Sonderzeichen",
    2030: "Dieser Benutzername ist geblockt",
    2040: "Der Code ist nicht vier Zeichen lang",
    2050: "Der Code enthält unzulässige Zeichen",
    2060: "Zu ihrer Sitzung konnte kein Token gefunden werden. Kehren Sie bitte zum 'https://login.aquarium-schwedt.de/rutschenkonfigurator' zurück um mit der Registrierung eines Nutzers zu beginnen!",
    2070: "Zu ihrer Sitzung konnte kein Token gefunden werden. Kehren Sie bitte zum 'https://login.aquarium-schwedt.de/rutschenkonfigurator' zurück um mit der Verknüpfung eines Nutzers zu beginnen!",
    2100: "Falsches Passwort",
    2110: "Der Benutzername ist nicht vergeben",
  },
  ScorePanel: {
    platzhalter: "Keine Scores vorhanden",
  },
  Highscores: {
    greeting: "Hi {name}",
    text: "Hier kannst du die Highscores einsehen.",
    punkte: "Punkte",
    punkte24: "Punkte (24h)",
    distanz: "Distanz",
    distanz24: "Distanz (24h)",
  },
  Dashboard: {
    greeting: "Hi {name}",
    btnCancel: "Abbrechen",
    btnConfirm: "Bestätigen",
    btnNew: "Neue Strecke erstellen",
    btnHighscores: "Highscores ansehen",
    distance: "Du bist schon <b> {distance}m </b> gerutscht.",
    lastSlide: "Deine Punkte vom letzten Rutschen: <b> {latestPoints} </b>",
    notYet: "Du bist bisher noch nicht gerutscht.",
    deleteAsk:
      "Möchtest du die ausgewählte Rutsche <b>{nameOfSelectedConfig}</b> löschen?",
    askTitle: "Bist du dir sicher?",
    description: "So funktioniert es",
    generalTitle: "Meine Strecken",
    generalText:
      "Du kannst bis zu sechs unterschiedliche Lieblingsslides gestalten. Bestehende Strecken können jederzeit verändert werden. Leg am besten gleich los!",
    step1Title: "1. Erstelle deine Strecke",
    step1Text:
      "Gib deiner Strecke einen Namen. Gestalte dann die drei Abschnitte mit jeweils einem Effekt, dessen Speed und seiner Farbe. Wähle zuletzt noch den passenden Soundtrack. Und fertig ist dein Slide!",
    step2Title: "2. Melde dich im AquariUM an",
    step2Text:
      "Im AquariUM meldest du dich mit deinem Nickname und deinem Passwort an und speicherst deine Strecken auf deinem Chip-Armband. Gehe dann zum Start und genieße deine persönlichen Slides!",
    step3Title: "3. Hab Spaß!",
    step3Text:
      "Jetzt heißt es rutschen, bis der Hosenboden glüht! Sammle Kilometer und Punkte! Deine Statistiken siehst du dann jederzeit in deinem Account.",
  },
};

const textePol = {
  Nav: {
    title: "Konfigurator zjeżdżalni",
    highscore: "Rekord",
    strecken: "Zjazdy",
  },
  Home: {
    title: "Konfigurator zjeżdżalni",
    subTitle:
      "Chcesz, aby Twoja wizyta w AquariUM była niezapomnianym przeżyciem? willst, dass dein Besuch im Eurothermen Resort etwas ganz besonderes wird?",
    text:
      "Nie ma sprawy! Przy pomocy konfiguratora zjeżdżalni możesz stworzyć swój własny profil zjazdowy już z domu lub w drodze do nas. Wybierz muzykę, światło i wiele innych spektakularnych efektów dla maksymalnie sześciu indywidualnych profili zjazdowych. A gdy już będziesz stać na progu zjeżdżalni, możesz wybrać swój własny lub jeden z trzech domyślnych profili zjazdowych.",
    textNewAccount: "Neu Jesteś tu nowy?",
    btnAnmelden: "Zaloguj się",
    btnRegistrieren: "Rejestracja",
    btnNewAccount: "Załóż konto",
    btnBack: "Wstecz",
    placeholderCode: "4-cyfrowy kod",
    labelPassword: "Hasło",
    confirm: "Potwierdź hasło",
    forgotPassword: "Zapomniałeś hasło?",
    anmelden: "Logowanie",
    registrieren: "Rejestracja",
    Impressum: "Stopka Redakcyjna",
    Datenschutz: "Datenschutz",
    Kontakt: "Kontakt",
  },
  Footer: {
    Impressum: "Stopka Redakcyjna",
    Datenschutz: "Ochrona danych",
    Kontakt: "Kontakt",
    linkImpressum: "https://aquarium-schwedt.de/impressum",
    linkDatenschutz: "https://aquarium-schwedt.de/datenschutz",
    linkKontakt: "https://aquarium-schwedt.de/service#kontakt",
  },
  Login: {
    title: "Witajcie miłośnicy zjeżdżalni!",
    text:
      "Zalogujcie się, podając swój login i hasło. Jak tylko się zalogujecie, będziecie mogli skonfigurować swoje zjazdy oraz obejrzeć swoje statystyki zjazdowe.",
    name: "Login",
    loggedIn:
      "Witaj {name}, jesteś już zalogowany(-na). Tutaj możesz się wylogować:,",
    loggedInAlternative:
      "Witaj <b>{newUser}</b>, jesteś jeszcze zalogowany(-na) jako <b>{name}</b>. Tutaj możesz się wylogować:",
    validation: "Twój login musi się składać z co najmniej 3 liter lub cyfr.",
    validationPassword: "Hasło musi się składać z 4 cyfr.",
    labelPassword: "Hasło",
    placeholderCode: "4-cyfrowy kod",
    connectProfile: "Zaloguj się i połącz",
    anmelden: "Zaloguj się",
    wait: "Proszę czekać...",
  },
  Register: {
    title: "Witajcie miłośnicy zjeżdżalni!",
    text:
      "Aby skonfigurować swoje zjazdy lub obejrzeć własne statystyki zjazdowe, musicie się najpierw zarejestrować. Zalogujcie się, podając swój login i hasło. Jak tylko się zalogujecie, będziecie mogli skonfigurować swoje zjazdy oraz obejrzeć statystyki zjazdowe.",
    name: "Login *",
    loggedIn:
      "Witaj {name}, jesteś już zalogowany(-na). Tutaj możesz się wylogować:",
    noToken:
      "Witaj, wróć proszę na stronę https://login.aquarium-schwedt.de/rutschenkonfigurator i kliknij pole „Dodaj nowego zjeżdżającego”.",
    validation: "Twój login musi się składać z co najmniej 3 liter lub cyfr.",
    validationHint: "3-12 litery lub cyfry",
    validationPassword: "Hasło musi się składać z 4 cyfr.",
    validationPassword2: "Hasła muszą być identyczne.",
    labelPassword: "Hasło *",
    labelPassword2: "Powtórz hasło *",
    placeholderCode: "4-cyfrowy kod",
    connectProfile: "Zaloguj się i połącz",
    register: "Zarejestruj się",
    wait: "Proszę czekać...",
    birthday: "Data urodzenia",
    gender: "Płeć",
    options: "Proszę wybrać",
    info: "Pola oznaczone * są polami obowiązkowymi.",
  },
  ConfigTile: {
    platzhalter: "Mamy miejsce na jeszcze jeden zjazd",
  },
  ConfiguratorStart: {
    title: "Konfigurator",
    nameIt: "Nadaj swojemu zjazdowi nazwę",
    instruction:
      "Puść wodze fantazji i wymyśl świetną nazwę dla swojej konfiguracji!",
    btnCancel: "Anuluj",
    btnGo: "Do dzieła",
  },
  Configurator: {
    title: "Nowy zjazd",
    btnNewSlide: "Utwórz zjazd",
    btnSaveSlide: "Zapisz zmiany",
    btnBack: "Wstecz",
    btnProceed: "Dalej",
    langsam: "bardzo powoli",
    normal: "normalna prędkość",
    schnell: "bardzo szybko",
    streckeVerwerfen: "Anuluj zjazd",
    streckeErstellen: "Utwórz zjazd",
    aenderungenVerwerfen: "Anuluj zmiany",
    aenderungenSpeichern: "Zapisz zmiany",
    frageZufrieden: "Nie jesteś zadowolony(-na)?",
    color: "Kolor",
    speed: "Prędkość",
    effekt: "Efekt",
    abschnitt: " Odcinek",
    musik: "Muzyka",

    instruction1:
      "Wybierz najpierw efekt świetlny dla {step} odcinka zjeżdżalni i ustaw prędkość. Następnie wybierz efekt kolorystyczny. W trybie podglądu możesz sprawdzić swój odcinek zjazdu. Jak zakończysz konfigurację, kliknij pole „Dalej”. Tak przejdziesz do {nextstep} odcinka.",
    instruction2:
      "Ustaw prędkość dla {step} odcinka zjeżdżalni. Następnie możesz wybrać efekt kolorystyczny. W trybie podglądu możesz sprawdzić swój odcinek zjazdu. Jak zakończysz konfigurację, kliknij pole „Dalej”. Tak przejdziesz do {nextstep} odcinka.",
    instruction3:
      "Ustaw prędkość dla {step} odcinka zjeżdżalni. Następnie możesz wybrać efekt kolorystyczny. W trybie podglądu możesz sprawdzić swój odcinek zjazdu. Jak zakończysz konfigurację, kliknij pole „Dalej”. Tak przejdziesz do menu wyboru muzyki.",
    title4: "Dobra robota!",

    instruction4:
      "Skonfigurowałeś już wszystkie odcinki zjeżdżalni! Brakuje już tylko podkładu muzycznego. Wybierz z listy swój ulubiony hit, którego próbki możesz także posłuchać. Jeśli muzyka też Ci odpowiada, kliknij pole „{label}“. Gotowe!",
    musicDescription: "Jak brzmi podkład muzyczny Twojego zjazdu?",
    music: "Muzyka",
    musicChoice: "Proszę wybrać",
  },
  LogoutDialog: {
    option1: "Wylogowanie i<br /> powrót do profilu zjeżdżającego",
    option2: "Powrót do profilu zjeżdżającego <b>bez</b> wylogowania<br />",
    btnCancel: "Anuluj",
    link: "https://login.aquarium-schwedt.de/rutschenkonfigurator",
  },
  MusicPlayer: {
    listen: "<b>Posłuchaj fragmentu</b>",
  },
  Notification: {
    title404: "Serwer jest niedostępny,",
    text404:
      "Serwer jest obecnie niedostępny. Proszę spróbować ponownie później.",
    title401: "Proszę sprawdzić wprowadzone dane",
    text401:
      "Serwer jest obecnie niedostępny. Proszę spróbować ponownie później.",
    titleGeneral: "Ups!",
    textGeneral: "Coś poszło nie tak. Proszę spróbować ponownie!",
    2000: "Nazwa użytkownika jest już używana. Wybierz inną nazwę.",
    2010: "Nazwa użytkownika jest za długa lub za krótka.",
    2015: "Proszę podać nazwę użytkownika i hasło.",
    2020: "Nazwa użytkownika zawiera znaki specjalne.",
    2030: "Ta nazwa użytkownika jest zablokowana.",
    2040: "Kod nie składa się z czterech cyfr.",
    2050: "Nazwa użytkownika jest za długa lub za krótka.",
    2060: "Nie znaleziono tokena dla Twojej sesji. Proszę wrócić na stronę 'https://login.aquarium-schwedt.de/rutschenkonfigurator', aby rozpocząć rejestrację od nowa!",
    2070: "Nie znaleziono tokena dla Twojej sesji. Proszę wrócić na stronę 'https://login.aquarium-schwedt.de/rutschenkonfigurator', aby zainicjować połączenie z użytkownikiem!",
    2100: "Nieprawidłowe hasło",
    2110: "Ta nazwa użytkownika nie istnieje",
  },
  ScorePanel: {
    platzhalter: "Brak punktów",
  },
  Highscores: {
    greeting: "Witaj {name}",
    text: "Tutaj możesz zobaczyć najlepsze wyniki.",
    punkte: "Punkty",
    punkte24: "Punkty (24 h)",
    distanz: "Odległość",
    distanz24: "Odległość (24 h)",
  },
  Dashboard: {
    greeting: "Witaj {name}",
    btnCancel: "Anuluj",
    btnConfirm: "Potwierdź",
    btnNew: "Utwórz nowy zjazd",
    btnHighscores: "Zobacz najlepsze wyniki",
    distance: "Pokonałeś(-łeś) już na zjeżdżalni <b>{distance}m</b>.",
    lastSlide: "Twoje punkty za ostatni zjazd: <b>{latestPoints}</b>",
    notYet: "Jeszcze tu nie zjeżdżałeś(-łaś).",
    deleteAsk:
      "Chcesz usunąć wybraną zjeżdżalnię <b>{nameOfSelectedConfig}</b>?",
    askTitle: "Jesteś pewien?",
    description: "Tak to działa",
    generalTitle: "Moje zjazdy",
    generalText:
      "Możesz skonfigurować maksymalnie trzy różnych zjazdów. Skonfigurowane zjazdy można w każdej chwili zmienić. Najlepiej od razu zabierz się do roboty!",
    step1Title: "1. Utwórz zjazd",
    step1Text:
      "Nadaj zjazdowi nazwę. Skonfiguruj trzy odcinków, wybierając dla nich efekt specjalny, prędkość i kolor. Na koniec wybierz odpowiedni podkład muzyczny. I Twoja konfiguracja jest gotowa!",
    step2Title: "2. Zaloguj się w AquariUM",
    step2Text:
      "W AquariUM logujesz się za pomocą swojego loginu i hasła i zapisujesz swoje zjazdy na bransoletce z chipem. Udaj się na start i delektuj się swoimi indywidualnie skonfigurowanymi zjazdami!",
    step3Title: "3. Dobrej zabawy!",
    step3Text:
      "Teraz pozostało Ci już tylko zjeżdżać do upadłego! Zbieraj kilometry i punkty! Twoje statystyki są w każdej chwili widoczne na Twoim koncie.",
  },
};

export default new MLCreate({
  initial: "deutsch",
  save: process.env.NODE_ENV === "production",
  middleware: (component, path) => {
    const newPath = `${component.$options.name}.${path}`;
    // you should return newPath
    return newPath;
  },
  languages: [
    new MLanguage("deutsch").create(texteDeu),
    new MLanguage("polnisch").create(textePol),
  ],
});
